/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

import { FetchSecretsInventoryFilterConfigLastModifiedAtOperatorEnum as OperatorEnum } from '../clients/cloud-vault-reporting/src/apis/VaultReportingServiceApi.ts';
export interface Filter {
  field: string;
  operator: '>' | '<' | '=';
  value: {
    type: 'string' | 'date' | 'duration' | 'list';
    value: string | number | string[];
  };
}

type FilterMap = { [key: string]: string | number | Date };

export const flattenFilters = <T = FilterMap>(filters: Filter[] = []): T => {
  return filters.reduce((acc: FilterMap, filter) => {
    const { field, operator, value } = filter;

    const key = `filter${field.charAt(0).toUpperCase()}${field.slice(1)}`;
    const dateOperators: Record<string, OperatorEnum> = {
      '>': OperatorEnum.GREATER_THAN,
      '<': OperatorEnum.LESS_THAN,
    };
    if (value.type === 'duration') {
      const serializedOperator = dateOperators[operator];
      acc[`${key}Operator`] = serializedOperator as string;
      acc[`${key}RelativeToNow`] = value.value as string;
    } else {
      acc[key] = value.value as string;
    }

    return acc;
  }, {} as FilterMap) as T;
};

// Export both named and default to satisfy different import patterns
const filters = {
  flattenFilters,
};

export default filters;
